import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/metadata`;

export const metadataService = {
  async getMetadata(entityType, entityId) {
    const response = await axios.get(`${API_BASE}/${entityType}/${entityId}`);
    return response.data;
  },

  async upsertMetadata(data) {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  async updateQualityDimensions(entityType, entityId, dimensions) {
    const response = await axios.put(`${API_BASE}/${entityType}/${entityId}/quality`, dimensions);
    return response.data;
  },

  async appendLineage(entityType, entityId, lineageEntry) {
    const response = await axios.post(`${API_BASE}/${entityType}/${entityId}/lineage`, lineageEntry);
    return response.data;
  },

  async findBelowThreshold(entityType, threshold = 0.5) {
    const response = await axios.get(`${API_BASE}/below-threshold/${entityType}?threshold=${threshold}`);
    return response.data;
  },
};

export default metadataService;
